module.exports = __webpack_public_path__ + "static/media/32.1dfd8aa6.svg";